import * as React from "react";
import { useEffect, useState } from "react";
import {
  ChakraProvider,
  Box,
  Text,
  Image,
  VStack,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Grid,
  theme,
  Card,
  CardBody,
  Flex,
  Avatar,
  Link,
  Tooltip,
  Divider,
} from "@chakra-ui/react";
import { ColorModeSwitcher } from "./ColorModeSwitcher";
import { Logo } from "./Logo";
import TimeAgo from "react-timeago";
import { InfoIcon } from "@chakra-ui/icons";

export const App = () => {
  const [solPrice, setSolPrice] = useState(0);
  const [ethPrice, setEthPrice] = useState(0);
  const [degodPrice, setDegodPrice] = useState(0);
  const [dustPrice, setDustPrice] = useState(0);
  const [dustPricePer, setDustPricePer] = useState(0);
  const [degodsSolFloor, setDegodsSolFloor] = useState(0);
  const [degodsSolPricePer, setDegodsSolPricePer] = useState(0);
  const [degodsETHFloor, setDegodsEthFloor] = useState(0);
  const [degodsETHPricePer, setDegodsETHPricePer] = useState(0);
  const [fuzzySolFloor, setFuzzySolFloor] = useState(0);
  const [fuzzySolPricePer, setFuzzySolPricePer] = useState(0);
  const [fuzzyEthFloor, setFuzzyEthFloor] = useState(0);
  const [fuzzyEthPricePer, setFuzzyEthPricePer] = useState(0);
  const [lastRefresh, setLastRefresh] = useState(0);
  const [count, setCount] = useState(0);

  const getSolPrice = async () => {
    const res = await fetch(
      "https://public-api.birdeye.so/defi/price?address=So11111111111111111111111111111111111111112",
      {
        headers: {
          "X-API-KEY": "39b1cd80ee4b47009f47c4cb4f1764f9",
        },
      }
    );
    const stats = await res.json();
    setSolPrice(stats.data.value);
  };

  const getDegodPrice = async () => {
    const res = await fetch(
      "https://public-api.birdeye.so/defi/price?address=degod39zqQWzpG6h4b7SJLLTCFE6FeZnZD8BwHBFxaN",
      {
        headers: {
          "X-API-KEY": "39b1cd80ee4b47009f47c4cb4f1764f9",
        },
      }
    );
    const stats = await res.json();
    setDegodPrice(stats.data.value);
  };

  const getEthPrice = async () => {
    const res = await fetch(
      "https://public-api.birdeye.so/defi/price?address=7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
      {
        headers: {
          "X-API-KEY": "39b1cd80ee4b47009f47c4cb4f1764f9",
        },
      }
    );
    const stats = await res.json();
    setEthPrice(stats.data.value);
  };

  const getDustPrice = async () => {
    const res = await fetch(
      "https://public-api.birdeye.so/defi/price?address=DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ",
      {
        headers: {
          "X-API-KEY": "39b1cd80ee4b47009f47c4cb4f1764f9",
        },
      }
    );
    const stats = await res.json();
    setDustPrice(stats.data.value);
    setDustPricePer(stats.data.value / 36);
  };

  const getDegodsSolFloor = async () => {
    const res = await fetch(
      "https://rest-api.hellomoon.io/v0/nft/collection/floorprice/batched",
      {
        method: "POST",
        headers: {
          authorization: "Bearer c27f025e-5c7e-4477-9fbf-cc561f04a956",
        },
        body: JSON.stringify({
          helloMoonCollectionId: ["4c6fadd5739f550bb7a392f48f73b744"],
        }),
      }
    );

    const stats = await res.json();
    const floor = stats.data[0].floorPriceLamports / 1000000000;
    const royalties = (floor / 100) * 3.33;
    const fees = (floor / 100) * 2.5;
    const calcFloor = floor + royalties + fees;

    setDegodsSolFloor(calcFloor);
    setDegodsSolPricePer((calcFloor / 550000) * solPrice);
  };

  const getDegodsEthFloor = async () => {
    const res = await fetch(
      "https://api.simplehash.com/api/v0/nfts/collection/b43dc80ada56435599e975f6f99300d8?limit=50",
      {
        headers: {
          "X-API-KEY": "soccertutori_sk_vhnkdiee7kwprp5g7e6kg0cvxcfocxyf",
        },
      }
    );

    const stats = await res.json();
    const price =
      stats.nfts[0].collection.floor_prices[0].value / 1000000000000000000;

    setDegodsEthFloor(price);
    setDegodsETHPricePer((price / 550000) * ethPrice);
  };

  const getFuzzySolFloor = async () => {
    const res = await fetch(
      "https://rest-api.hellomoon.io/v0/nft/collection/floorprice/batched",
      {
        method: "POST",
        headers: {
          authorization: "Bearer c27f025e-5c7e-4477-9fbf-cc561f04a956",
        },
        body: JSON.stringify({
          helloMoonCollectionId: ["b11bfb411ffcabbdfe274f3de9dd63f2"],
        }),
      }
    );

    const stats = await res.json();
    const floor = stats.data[0].floorPriceLamports / 1000000000;
    const royalties = (floor / 100) * 3.33;
    const fees = (floor / 100) * 2.5;
    const calcFloor = floor + royalties + fees;

    setFuzzySolFloor(calcFloor);
    setFuzzySolPricePer((calcFloor / 120000) * solPrice);
  };

  const getFuzzyEthFloor = async () => {
    const res = await fetch(
      "https://api.simplehash.com/api/v0/nfts/collection/76e57035054e8b5be6cbefd078c1b015?limit=50",
      {
        headers: {
          "X-API-KEY": "soccertutori_sk_vhnkdiee7kwprp5g7e6kg0cvxcfocxyf",
        },
      }
    );

    const stats = await res.json();
    const price =
      stats.nfts[0].collection.floor_prices[0].value / 1000000000000000000;

    setFuzzyEthFloor(price);
    setFuzzyEthPricePer((price / 120000) * ethPrice);
  };

  useEffect(() => {
    getEthPrice();
    getSolPrice();
    getDegodPrice();
  }, []);

  useEffect(() => {
    getDegodsSolFloor();
    getFuzzySolFloor();
    getDustPrice();
    setLastRefresh(Date.now());
  }, [solPrice]);

  useEffect(() => {
    getDegodsEthFloor();
    getFuzzyEthFloor();
  }, [ethPrice]);

  useEffect(() => {
    //Implementing the setInterval method
    const interval = setInterval(() => {
      setCount(count + 1);
      getDegodsSolFloor();
      getDegodsEthFloor();
      getFuzzySolFloor();
      getFuzzyEthFloor();
      getDustPrice();
      getEthPrice();
      getSolPrice();
      getDegodPrice();
      setLastRefresh(Date.now());
    }, 60000);

    //Clearing the interval
    return () => clearInterval(interval);
  }, [count]);

  return (
    <ChakraProvider theme={theme}>
      <Box
        textAlign="center"
        fontSize="xl"
        fontFamily={"Open Sans"}
        fontWeight={600}
      >
        <Grid minH="100vh" p={3}>
          <ColorModeSwitcher justifySelf="flex-end" />
          <VStack maxW={"calc(100vw - 30px)"}>
            <Flex alignItems={"center"}>
              <Logo w={"200px"} h={"100px"} pointerEvents="none" mr={6} />
              <Divider h={"60px"} orientation="vertical" />
              <Text fontSize={30} ml={6}>
                ${degodPrice.toFixed(5)}
              </Text>
            </Flex>
            <Card maxW={"calc(100vw - 30px)"}>
              <CardBody>
                <TableContainer>
                  <Table variant="simple">
                    <Thead>
                      <Tr>
                        <Th>Project</Th>
                        <Th>
                          <Flex alignItems={"center"}>
                            <Tooltip label="2.5% ME base fees added, could be lower depending on marketplace or your level.">
                              <Flex alignItems={"center"}>
                                Price <InfoIcon ml={1} />
                              </Flex>
                            </Tooltip>
                          </Flex>
                        </Th>
                        <Th isNumeric>
                          <Flex alignItems={"center"}>
                            <Tooltip label="Compared to native currency e.g. SOL and ETH">
                              <Flex alignItems={"center"}>
                                Price per $DEGOD <InfoIcon ml={1} />
                              </Flex>
                            </Tooltip>
                          </Flex>
                        </Th>
                        <Th isNumeric>
                          <Flex alignItems={"center"}>
                            <Tooltip label="Red means buyng the token is cheaper, green means buying the nft is cheaper">
                              <Flex alignItems={"center"}>
                                Difference <InfoIcon ml={1} />
                              </Flex>
                            </Tooltip>
                          </Flex>
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      <Tr>
                        <Td border={"none"}>
                          <Flex alignItems={"center"}>
                            <Avatar
                              w={"28px"}
                              h={"28px"}
                              mr={2}
                              src="https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https://nftstorage.link/ipfs/bafkreig2lmtuqefz23spu4kxxzzyowpccaqwbjnle5lznucl7ucesct5kq"
                            />{" "}
                            DeGods
                          </Flex>
                        </Td>
                        <Td border={"none"}>{degodsSolFloor.toFixed(2)} SOL</Td>
                        <Td border={"none"} isNumeric>
                          ${degodsSolPricePer.toFixed(5)}
                        </Td>
                        <Td>
                          {degodsSolPricePer !== 0 && (
                            <Text
                              color={
                                degodsSolPricePer - degodPrice > 0
                                  ? "red"
                                  : "green"
                              }
                            >
                              ${(degodsSolPricePer - degodPrice).toFixed(5)}
                            </Text>
                          )}
                        </Td>
                      </Tr>
                      <Tr>
                        <Td border={"none"}>
                          <Flex alignItems={"center"}>
                            <Avatar
                              w={"28px"}
                              h={"28px"}
                              mr={2}
                              src="https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https://nftstorage.link/ipfs/bafkreig2lmtuqefz23spu4kxxzzyowpccaqwbjnle5lznucl7ucesct5kq"
                            />{" "}
                            DeGods (ETH)
                          </Flex>
                        </Td>
                        <Td border={"none"}>{degodsETHFloor.toFixed(2)} ETH</Td>
                        <Td border={"none"} isNumeric>
                          ${degodsETHPricePer.toFixed(5)}
                        </Td>
                        <Td border={"none"}>
                          {degodsETHPricePer !== 0 && (
                            <Text
                              color={
                                degodsETHPricePer - degodPrice > 0
                                  ? "red"
                                  : "green"
                              }
                            >
                              ${(degodsETHPricePer - degodPrice).toFixed(5)}
                            </Text>
                          )}
                        </Td>
                      </Tr>
                      <Tr>
                        <Td border={"none"}>
                          {" "}
                          <Flex alignItems={"center"}>
                            <Avatar
                              mr={2}
                              w={"28px"}
                              h={"28px"}
                              src="https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https://bafkreidc5co72clgqor54gpugde6tr4otrubjfqanj4vx4ivjwxnhqgaai.ipfs.nftstorage.link/"
                            />{" "}
                            Fuzzy DeGods
                          </Flex>
                        </Td>
                        <Td border={"none"}>{fuzzySolFloor.toFixed(2)} SOL</Td>
                        <Td border={"none"} isNumeric>
                          ${fuzzySolPricePer.toFixed(5)}
                        </Td>
                        <Td border={"none"}>
                          {fuzzySolPricePer !== 0 && (
                            <Text
                              color={
                                fuzzySolPricePer - degodPrice > 0
                                  ? "red"
                                  : "green"
                              }
                            >
                              ${(fuzzySolPricePer - degodPrice).toFixed(5)}
                            </Text>
                          )}
                        </Td>
                      </Tr>
                      <Tr>
                        <Td border={"none"}>
                          {" "}
                          <Flex alignItems={"center"}>
                            <Avatar
                              mr={2}
                              w={"28px"}
                              h={"28px"}
                              src="https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https://bafkreidc5co72clgqor54gpugde6tr4otrubjfqanj4vx4ivjwxnhqgaai.ipfs.nftstorage.link/"
                            />{" "}
                            Fuzzy DeGods (ETH)
                          </Flex>
                        </Td>
                        <Td border={"none"}>{fuzzyEthFloor.toFixed(2)} ETH</Td>
                        <Td border={"none"} isNumeric>
                          ${fuzzyEthPricePer.toFixed(5)}
                        </Td>
                        <Td border={"none"}>
                          {fuzzyEthPricePer !== 0 && (
                            <Text
                              color={
                                fuzzyEthPricePer - degodPrice > 0
                                  ? "red"
                                  : "green"
                              }
                            >
                              ${(fuzzyEthPricePer - degodPrice).toFixed(5)}
                            </Text>
                          )}
                        </Td>
                      </Tr>
                      <Tr>
                        <Td border={"none"}>
                          {" "}
                          <Flex alignItems={"center"}>
                            <Avatar
                              mr={2}
                              w={"28px"}
                              h={"28px"}
                              src="https://s2.coinmarketcap.com/static/img/coins/64x64/18802.png"
                            />{" "}
                            DUST
                          </Flex>
                        </Td>
                        <Td border={"none"}>${dustPrice.toFixed(3)}</Td>
                        <Td border={"none"} isNumeric>
                          ${dustPricePer.toFixed(5)}
                        </Td>
                        <Td border={"none"}>
                          {dustPricePer !== 0 && (
                            <Text
                              color={
                                dustPricePer - degodPrice > 0 ? "red" : "green"
                              }
                            >
                              ${(dustPricePer - degodPrice).toFixed(5)}
                            </Text>
                          )}
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
                <Text fontSize={14} fontWeight={400} mt={2}>
                  {" "}
                  Last refresh: <TimeAgo date={lastRefresh} />
                </Text>
              </CardBody>
            </Card>
          </VStack>
        </Grid>
        <Flex pos={"absolute"} bottom={2} justifyContent={"center"} w={"100%"}>
          <Text fontSize={13} fontStyle={"italic"}>
            Hacked together in about 20 minutes by{" "}
            <Link
              target="_blank"
              href="https://x.com/nifty_dev"
              textDecoration={"underline"}
            >
              Nifty
            </Link>
          </Text>
        </Flex>
      </Box>
    </ChakraProvider>
  );
};
